<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormLayout
          :initial="contentArticle.attributes"
          :errors="errors"
          :content-article-categories="contentArticleCategories"
          :content-article-labels="contentArticleLabels"
          :content-article-flags="contentArticleFlags"
          :portal="portal"
          :url="portal.attributes.base_url + '/' + contentArticle.attributes.path"
          :edit="true"
          :company-id="contentArticle.attributes.company_id"
          @submit="submit"
          @edit-author="editAuthor"
          @copy="copy"
          @mail="mail"
      />

      <CopyModal :content-article="contentArticle"/>

      <MailModal :content-article="contentArticle" :portal="portal"/>

      <EditModal :content-article="contentArticle" @updated="contentArticle = $event"></EditModal>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import CopyModal from '../../../../../../../components/Modals/Administration/Content/ContentArticles/Copy'
import MailModal from '../../../../../../../components/Modals/Administration/Content/ContentArticles/Mail'
import EditModal from '../../../../../../../components/Modals/Administration/Content/ContentArticleAuthors/Edit'
import FormLayout from '../../../../../../../components/Administration/ContentArticles/Layouts/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {CopyModal,EditModal, LoadingContainer, FormLayout,MailModal},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentArticle: null,
      contentArticleCategories: null,
      contentArticleLabels: null,
      contentArticleFlags: null,
      portals: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/content-articles/' + this.$route.params.contentArticleId),
        http.get('/api/v2/content-article-categories', {'filter[portal_id]': this.$route.params.portalId, page_size: 100}),
        http.get('/api/v2/content-article-labels', {'filter[portal_id]': this.$route.params.portalId, page_size: 100}),
        http.get('/api/v2/content-article-flags', {'filter[portal_id]': this.$route.params.portalId, page_size: 100}),
      ]).then(responses => {
        this.contentArticle = responses[0].data.data

        this.contentArticleCategories = responses[1].data.data

        this.contentArticleLabels = responses[2].data.data

        this.contentArticleFlags = responses[3].data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-articles/' + this.$route.params.contentArticleId, data)
          .then(response => {
            notify.success('The content article was saved')

            this.contentArticle = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },

    editAuthor() {
      $('#edit-content-article-author-modal').modal('show')
    },

    copy() {
      $('#copy-content-article-modal').modal('show')
    },

    mail() {
      $('#mail-content-article-modal').modal('show')
    }
  }
}
</script>
